module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_N.2e333ec4.jpg";